import { useTranslation } from "react-i18next";
import { DesktopDialog } from "../app/DesktopDialog";
import { PartnersList } from "./PartnersList";

/**
 * The partners of Juisci in a dialog over the last onboarding step of a
 * desktop (Figma D7, 5588:237064). Never over another modal: the settings
 * show the list as a page of their own.
 * The list scrolls under the title when the window is short.
 */
export function PartnersDialog({
  onClose,
}: {
  onClose: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <DesktopDialog
      presentation="modal"
      title={t("Our partners")}
      header={{ layout: "inline" }}
      subtitle={null}
      onClose={onClose}
      footer={null}
    >
      <div className="w-full">
        <PartnersList layout="desktop" policies={null} />
      </div>
    </DesktopDialog>
  );
}
